var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477.9 477.9",
    style: {
      enableBackground: "new 0 0 477.9 477.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.7,67.9c-14.5-40.6-53-67.8-96.1-67.9c-43.4,0.1-82,27.4-96.4,68.3H85.5c-47.1,0.1-85.3,38.2-85.3,85.3 v238.9c0.1,47.1,38.2,85.3,85.3,85.3h238.9c47.1-0.1,85.3-38.2,85.3-85.3V198.8C463,179.8,490.7,121.2,471.7,67.9z M375.6,392.5 c0,28.3-22.9,51.2-51.2,51.2H85.5c-28.3,0-51.2-22.9-51.2-51.2V153.6c0-28.3,22.9-51.2,51.2-51.2h187.7 c0.1,56.5,45.9,102.3,102.4,102.4L375.6,392.5L375.6,392.5z M375.6,170.7c-37.7,0-68.3-30.6-68.3-68.3s30.6-68.3,68.3-68.3 s68.3,30.6,68.3,68.3S413.3,170.7,375.6,170.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#30AB00",
    cx: 375.5,
    cy: 102.4,
    r: 102.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.9,399.5c-2.4,2.4-5.6,3.7-9,3.7c-3.4,0-6.6-1.3-9-3.7L86.4,328c-7.4-7.4-7.4-19.5,0-26.9l9-9 c7.4-7.4,19.5-7.4,26.9,0l44.7,44.7l120.7-120.7c7.4-7.4,19.5-7.4,26.9,0l9,9c7.4,7.4,7.4,19.5,0,26.9L175.9,399.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOn);
export default __webpack_public_path__ + "static/media/notification-on.6dd5d5260cef4b7f196c17913f5e6d1b.svg";
export { ForwardRef as ReactComponent };